export default __webpack_public_path__ + "static/media/competition_day.a5b71842.jpg";